import React from 'react';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Components
import { WpCollapsible } from 'Wpds/components/collapsible';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './SurfaceFilterBlock.scss';

type Props = {
  title: string;
  children?: React.ReactNode;
  count?: number;
};

const SurfaceFilterBlock = ({ title, count = 0, children }: Props) => {
  const [isExpanded, toggleIsExpanded] = useToggle(true);
  const baseClassName = 'SurfaceFilterBlock';

  const showCount = count > 0;

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__title`}>
        <WpButton variant="tertiary" size="sm" onClick={toggleIsExpanded}>
          <WpIcon name={isExpanded ? 'angle-down' : 'angle-right'} />
          {title}
        </WpButton>
        {showCount && <div className={`${baseClassName}__title__count`}>{count}</div>}
      </div>
      <WpCollapsible open={isExpanded}>
        <div className={`${baseClassName}__items`}>{children}</div>
      </WpCollapsible>
    </div>
  );
};

export default SurfaceFilterBlock;
